import { Component } from "react"
import { Container, Row, Col, Card, Form, FormLabel } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'

import BootstrapTable from 'react-bootstrap-table-next'
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter'
import paginationFactory from 'react-bootstrap-table2-paginator'
import Select from 'react-select'
import DatePicker from "react-datepicker"
import moment from 'moment'

import { CgPassword } from 'react-icons/cg'
import { FiUserPlus, FiUserX, FiVideoOff, FiVideo, FiEdit } from 'react-icons/fi'
import { BsGraphUp, BsGraphDown } from 'react-icons/bs'
import { BiCommentDetail, BiSortDown, BiSortUp } from 'react-icons/bi'
import { AiOutlineDelete } from 'react-icons/ai'
import { GiVideoConference } from 'react-icons/gi'
import { MdDeleteForever, MdLibraryBooks, MdAssignment, MdAssignmentLate } from 'react-icons/md'
import Spinner from '../Components/Spinner'

import * as data from '../Utilities/loadData'
import * as ajax from '../Utilities/ajax'

import NewUser from '../Dialogs/NewUser'
import NewVideo from '../Dialogs/NewVideo'
import ChgPwd from '../Dialogs/ChangePassword'
import PreDes from '../Dialogs/PreviewDescription'
import DisUser from '../Dialogs/DisableUser'
import DeUser from '../Dialogs/DeleteUser'
import DisVideo from '../Dialogs/DisableVideo'
import DeVideo from '../Dialogs/DisableVideo'
import WelcomeVideo from '../Dialogs/WelcomeVideo'
import HandleTagOrSection from '../Dialogs/handleSectionOrTag'
import ReportVideo from '../Dialogs/Report_Video'
import { IconButton } from "@material-ui/core"
import { FaUserFriends } from 'react-icons/fa'
import { GrView } from 'react-icons/gr'
import { GiHomeGarage } from 'react-icons/gi'
import HandleCompany from '../Dialogs/handleCompany'
import Auth from "../Utilities/Auth"

import FileDownload from "react-file-download"
import { LightTooltip } from "../Components/LigthTooptip"

class Admin extends Component {


  static MENUS = {
    "ADJUST_REPORT_DATA": "Adjust Report Data",
    "USER_MANAGEMENT": "User Management",
    "ADJUST_VIDEO_DATA": "Adjust Video Data",
    "ADJUST_USER_VIDEO_VIEWER": "Report Video",
    "ADJUST_USER_REPORT_VIEWER": "Report Equity Research",
  }

  state = {
    selectedMenu: "User Management",
    // User Management
    datas: [],
    videos: [],
    comapnys: [],
    userVideoViewer: [],
    userReportViewer: [],

    dialogNewUser: {
      show: false,
      val: undefined,
      // page: "new"
    },

    dialogWelcomeVideo: {
      show: false,
      val: undefined,
    },
    dialogReportVideo: {
      show: false,
      val: { user: undefined },
    },
    dialogChgPwd: {
      show: false,
      val: undefined,
    },
    dialogDetail: {
      show: false,
      val: undefined,
      row: {},
      page: "edit"
    },
    dialogDisUser: {
      show: false,
      val: undefined,
      curStatus: undefined,
      key: undefined,
    },
    dialogDisVideo: {
      show: false,
      val: undefined,
      curStatus: undefined,
    },
    dialogDeVideo: {
      show: false,
      val: undefined,
      curStatus: undefined,
    },
    dialogNewVideo: {
      show: false,
      val: undefined,
    },
    dialogDeleteUser: {
      show: false,
      val: undefined,
    },
    dialogPreDes: {
      show: false,
      val: undefined,
      tags: [],
    },
    dialogData: {
      show: false,
      val: undefined,
      key: undefined,
      page: undefined
    },
    dialogDataUser: {
      show: false,
      val: undefined,
      key: undefined,
      page: undefined
    },

    // Adjust Report Data
    tpSymbol: undefined,
    tpFactor: undefined,
    tpSaving: false,
    tpResult: undefined,

    reportFrom: 1,
    reportFromTitle: 1,

    tags: [],
    sections: [],
    _company: [],
    _library: [],
    section: undefined,
    username: undefined,
    company: undefined,
    videoId: undefined,
    libraryId: undefined,
    from: new Date(),
    fromReport: new Date(),
    to: new Date(),
    toReport: new Date(),
    loading: false,
  }
  loading = true

  componentDidMount = async () => {
    this.reload()
    this.reloadVideo()
    const task1 = data.tags()
    const task2 = data.sections()
    const task3 = data.company()
    const task4 = data.library()

    let tags = []
    let sections = []
    let _company = []
    let _library = []

    await Promise.all([
      task1.then(value => tags = value),
      task2.then(value => sections = value),
      task3.then(value => _company = value),
      task4.then(value => _library = value)
    ])

    this.setState({ tags, sections, _company, _library })
  }

  reload = () => {
    return ajax.get("/user/list").then(result => {
      this.setState({ datas: result.data })
      this.setState({ comapnys: JSON.parse(JSON.stringify(result.data)) })
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [1]")
    })
  }

  reloadVideo = () => {
    return ajax.get("/video/listAdmin").then(result => {
      this.setState({ videos: result.data })
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [2]")
    })
  }

  deleteUser = (id) => {
    return ajax.post("/user/delete", { id }).then(result => {
      const dialogDeleteUser = {
        show: false,
        val: undefined,
      }
      const Newdata = this.state.datas.filter((d) => d.id !== id)
      this.setState({ dialogDeleteUser, datas: Newdata })
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [3]")
    })
  }

  optionsCompanys = () => {
    let companys = JSON.parse(JSON.stringify(((this.state || {}).comapnys || []).filter(u => u.company)))
    let companyName = []
    for (const company of companys) {
      if (!companyName.find(u => u.value === company.company))
        companyName.push({
          value: company.company,
          label: company.company
        })
    }
    return companyName
  }

  options = () => {
    let users = JSON.parse(JSON.stringify(((this.state || {}).datas || [])))
    for (const user of users) {
      user.value = user.username
      user.label = user.username
    }
    return users
  }

  optionsVideo = () => {
    let videos = ((this.state || {}).videos || [])
    for (const video of videos) {
      video.value = video.title
      video.label = video.title
    }
    return videos
  }

  handleChangeReportUser = (e) => {
    e ? this.setState({ username: e.username }) : this.setState({ username: undefined })
  }
  handleChangeReportCompany = (e) => {
    e ? this.setState({ company: e.value }) : this.setState({ company: undefined })
  }
  handleChangeLibraryViewer = (e) => {
    e ? this.setState({ libraryId: e.value }) : this.setState({ libraryId: undefined })
  }
  handleChangeReportViewer = (e) => {
    e ? this.setState({ videoId: e.id }) : this.setState({ videoId: undefined })
  }

  getUserViewer = () => {
    const { videoId, username, company, reportFrom } = this.state
    this.setState({ loading: true })
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()

    let _where = {
      from,
      to,
      reportFrom,
      videoId: undefined, username: undefined, company: undefined,
    }

    if (reportFrom === 1) _where.username = username
    if (reportFrom === 2) _where.company = company
    if (reportFrom === 3) _where.videoId = videoId

    const where = JSON.stringify(_where)

    return ajax.get("/video/userviewer?where=" + where).then(result => {
      const userVideoViewer = result.data.viewers.length > 0 ? result.data.viewers : []
      this.setState({ userVideoViewer, loading: false })
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [4]")
    })
  }

  render = () => {

    const { reportFrom, _library, reportFromTitle, userVideoViewer, selectedMenu, tpSymbol, tpFactor, tpSaving, tpResult, sections, section, videos, userReportViewer } = this.state
    const _videos = section ? videos.filter(v => v.section === section).sort(function (a, b) { return parseInt(a.video_order) - parseInt(b.video_order) }) : videos

    return (
      <Container fluid className="style-admin" >
        { // Top Level Menu
          <Row style={{ marginBottom: "1rem" }}>
            <Col style={{ marginTop: 8, marginBottom: 8 }}>
              <a href="/dashboard" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontSize: 30,
                  textDecoration: "none",
                  color: "RGB(0,37,97)",
                }}
              >HOME</a>
              <span style={{ marginLeft: 10, marginRight: 10, fontSize: 24 }}>|</span>
              <a href="#" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontWeight: selectedMenu === Admin.MENUS.USER_MANAGEMENT ? "bold" : "normal",
                  fontSize: 30,
                  textDecoration: "none",
                  color: selectedMenu === Admin.MENUS.USER_MANAGEMENT ? "RGB(243,122,33)" : "RGB(0,37,97)",
                }}
                onClick={() => this.setState({ section: undefined, dialogNewUser: { show: false, val: undefined }, dialogDisUser: { show: false, val: undefined, key: undefined }, selectedMenu: Admin.MENUS.USER_MANAGEMENT })}
              >{Admin.MENUS.USER_MANAGEMENT}</a>
              <span style={{ marginLeft: 10, marginRight: 10, fontSize: 24 }}>|</span>
              <a href="#" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontWeight: selectedMenu === Admin.MENUS.ADJUST_REPORT_DATA ? "bold" : "normal",
                  fontSize: 30,
                  textDecoration: "none",
                  color: selectedMenu === Admin.MENUS.ADJUST_REPORT_DATA ? "RGB(243,122,33)" : "RGB(0,37,97)",
                }}
                onClick={() => this.setState({ section: undefined, selectedMenu: Admin.MENUS.ADJUST_REPORT_DATA })}
              >{Admin.MENUS.ADJUST_REPORT_DATA}</a>
              <span style={{ marginLeft: 10, marginRight: 10, fontSize: 24 }}>|</span>
              <a href="#" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontWeight: selectedMenu === Admin.MENUS.ADJUST_VIDEO_DATA ? "bold" : "normal",
                  fontSize: 30,
                  textDecoration: "none",
                  color: selectedMenu === Admin.MENUS.ADJUST_VIDEO_DATA ? "RGB(243,122,33)" : "RGB(0,37,97)",
                }}
                onClick={() => this.setState({ dialogDisVideo: { show: false, val: undefined, curStatus: undefined }, selectedMenu: Admin.MENUS.ADJUST_VIDEO_DATA })}
              >{Admin.MENUS.ADJUST_VIDEO_DATA}</a>
              <span style={{ marginLeft: 10, marginRight: 10, fontSize: 24 }}>|</span>
              <a href="#" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontWeight: selectedMenu === Admin.MENUS.ADJUST_USER_VIDEO_VIEWER ? "bold" : "normal",
                  fontSize: 30,
                  textDecoration: "none",
                  color: selectedMenu === Admin.MENUS.ADJUST_USER_VIDEO_VIEWER ? "RGB(243,122,33)" : "RGB(0,37,97)",
                }}
                onClick={() => this.setState({ section: undefined, selectedMenu: Admin.MENUS.ADJUST_USER_VIDEO_VIEWER })}
              >{Admin.MENUS.ADJUST_USER_VIDEO_VIEWER}</a>
              <span style={{ marginLeft: 10, marginRight: 10, fontSize: 24 }}>|</span>
              <a href="#" // eslint-disable-line
                style={{
                  paddingTop: 10,
                  fontWeight: selectedMenu === Admin.MENUS.ADJUST_USER_REPORT_VIEWER ? "bold" : "normal",
                  fontSize: 30,
                  textDecoration: "none",
                  color: selectedMenu === Admin.MENUS.ADJUST_USER_REPORT_VIEWER ? "RGB(243,122,33)" : "RGB(0,37,97)",
                }}
                onClick={() => this.setState({ section: undefined, selectedMenu: Admin.MENUS.ADJUST_USER_REPORT_VIEWER })}
              >{Admin.MENUS.ADJUST_USER_REPORT_VIEWER}</a>
            </Col>
          </Row>
        }

        {selectedMenu === Admin.MENUS.USER_MANAGEMENT &&
          <>
            <Row>
              <Col>
                <Button variant="outline-secondary" onClick={() => this.initDialogNewUser()}>{"+ New User"}</Button>
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                <BootstrapTable
                  keyField='id'
                  id="admin-user"
                  wrapperClasses="table-responsive"
                  striped hover bootstrap4
                  data={this.state.datas}
                  columns={this.genColumns()}
                  filter={filterFactory()}
                  pagination={paginationFactory({
                    sizePerPage: 10,
                    hidePageListOnlyOnePage: true,
                    hideSizePerPage: true,
                  })}
                />
              </Col>
            </Row>

            <NewUser open={this.state.dialogDetail} company={this.state._company} handleData={this.handleDataUser} detail={true} callback={this.handleNewUser} cancel={this.userCancel} />
            <NewUser open={this.state.dialogNewUser} handleData={this.handleDataUser} company={this.state._company} callback={this.handleNewUser} cancel={this.userCancel} />
            <ChgPwd open={this.state.dialogChgPwd} callback={this.handleChgPwd} />
            <DisUser open={this.state.dialogDisUser} callback={this.handleDisUser} />
            <DeUser open={this.state.dialogDeleteUser} callback={this.deleteUser} />
            <HandleCompany open={this.state.dialogDataUser} callback={this.handleDataKeyUser} />
          </>
        }

        {selectedMenu === Admin.MENUS.ADJUST_REPORT_DATA &&
          <Card style={{ padding: 10 }}>
            <Row>
              <Col xs={12} md={2} lg={2} style={{ fontWeight: "bold", marginTop: 5, paddingBottom: 4, fontSize: 20 }}>Target Price</Col>
              <Col xs={5} md={3} lg={3}>
                <Form.Control placeholder="Stock Symbol w/o TB"
                  value={tpSymbol || ""}
                  onChange={e => this.setState({ tpSymbol: e.target.value, tpResult: undefined })}
                />
              </Col>
              <Col xs={5} md={3} lg={3}>
                <Form.Control placeholder="Adjustment Factor"
                  value={tpFactor || ""}
                  onChange={e => {
                    if (/^-?\d*\.?\d*$/.test(e.target.value)) // allow only floating point with sign
                      this.setState({ tpFactor: e.target.value, tpResult: undefined })
                  }}
                />
              </Col>
              <Col xs={2} md={2} lg={1}>
                <Button block
                  onClick={async () => {
                    this.setState({ tpSaving: true })
                    const tpResult = await ajax.post(`/data/tpFactor?symbol=${tpSymbol}`, { value: parseFloat(tpFactor) })
                    this.setState({ tpSaving: false, tpResult })
                  }}
                  disabled={!tpSymbol || !parseFloat(tpFactor)}
                  loading={tpSaving}
                >
                  {tpSaving ? "" : "Run"}
                </Button>
              </Col>
              {tpResult !== undefined &&
                <Col xs={12} md={2} lg={2} style={{ marginTop: 5 }}>
                  {(tpResult || {}).data ? <span style={{ color: "#007F00" }}>{`Adjusted: ${tpResult.data.affectedRows}`}</span> : <span style={{ color: "red" }}>Failed</span>}
                </Col>
              }
            </Row>
          </Card>
        }

        {selectedMenu === Admin.MENUS.ADJUST_VIDEO_DATA &&
          <>
            <Row>
              <Col style={{ marginTop: 10 }}>
                <Button variant="outline-secondary" onClick={() => this.initDialogNewVideo()}>{"+ New Video"}</Button>
              </Col>
              <Col style={{ marginTop: 10 }} sm={{ span: 6, offset: 1 }} lg={{ span: 4, offset: 4 }}>
                <Select
                  className="basic-single"
                  classNamePrefix="Select Group"
                  onChange={this.handleChangeSection}
                  isClearable
                  isSearchable
                  placeholder={"Select Group"}
                  name="section"
                  options={sections}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                <BootstrapTable
                  keyField='id'
                  id="admin-video"
                  wrapperClasses="table-responsive"
                  striped hover bootstrap4
                  data={_videos}
                  columns={this.genVideoColumns()}
                  filter={filterFactory()}
                  pagination={paginationFactory({
                    sizePerPage: 10,
                    hidePageListOnlyOnePage: true,
                    hideSizePerPage: true,
                  })}
                />
              </Col>
            </Row>

            <PreDes tags={this.state.tags} handleData={this.handleData} sections={sections} open={this.state.dialogPreDes} callback={this.handleDescription} />
            <HandleTagOrSection open={this.state.dialogData} key={this.state.dialogData.key} val={this.state.dialogData.val} callback={this.handleDataKey} />
            <NewVideo tags={this.state.tags} handleData={this.handleData} sections={sections} open={this.state.dialogNewVideo} callback={this.handleNewVideoCallback} />
            <DisVideo open={this.state.dialogDisVideo} callback={this.handleDisVideo} />
            <DeVideo open={this.state.dialogDeVideo} callback={this.handleDeleteVideo} />
            <WelcomeVideo open={this.state.dialogWelcomeVideo} callback={this.CollDialogWelcome} />
          </>
        }

        {selectedMenu === Admin.MENUS.ADJUST_USER_VIDEO_VIEWER &&
          <>
            <Row>
              <Col xs={4} sm={{ offset: 1 }} style={{ marginTop: "10px" }} lg={{ span: 1, offset: 1 }}><FormLabel style={{ width: "100px" }}>Period From</FormLabel></Col>
              <Col xs={8} style={{ marginTop: "10px" }} lg={2}>
                <DatePicker selected={this.state.from} dateFormat="dd/MM/yyyy" onChange={date => this.setState({ from: date })} />
              </Col>
              <Col xs={4} sm={{ offset: 1 }} style={{ marginTop: "10px" }} lg={1}><FormLabel style={{ width: "100px" }}>Period To</FormLabel></Col>
              <Col xs={8} style={{ marginTop: "10px" }} lg={2}>
                <DatePicker selected={this.state.to} dateFormat="dd/MM/yyyy" onChange={date => this.setState({ to: date })} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReport({ key: 1 })} defaultChecked={reportFrom === 1} name="radio" /></Col>
              <Col xs={3} lg={1}><FormLabel >Username</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={this.options()} isDisabled={reportFrom !== 1} onChange={(e) => this.handleChangeReportUser(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReport({ key: 2 })} defaultChecked={reportFrom === 2} name="radio" /></Col>
              <Col xs={3} lg={1}><FormLabel>Company</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={this.optionsCompanys()} isDisabled={reportFrom !== 2} onChange={(e) => this.handleChangeReportCompany(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReport({ key: 3 })} defaultChecked={reportFrom === 3} name="radio" /></Col>
              <Col xs={3} lg={1}  ><FormLabel style={{ width: "100px" }}>Video Name</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={this.optionsVideo()} isDisabled={reportFrom !== 3} onChange={(e) => this.handleChangeReportViewer(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={12} style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outline-secondary" disabled={this.state.loading} onClick={() => this.getUserViewer()}>Search</Button>
                <Button style={{ marginLeft: 15 }} variant="outline-secondary" disabled={this.state.loading} onClick={() => this.downloadCsv()}>Download</Button>
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                {this.state.loading ? <Spinner />
                  : <BootstrapTable
                    keyField='id'
                    id="admin-report"
                    wrapperClasses="table-responsive"
                    striped hover bootstrap4
                    data={userVideoViewer}
                    columns={this.genVideoViewerColumns()}
                    filter={filterFactory()}
                    pagination={paginationFactory({
                      sizePerPage: 10,
                      hidePageListOnlyOnePage: true,
                      hideSizePerPage: true,
                    })}
                  />}
              </Col>
            </Row>
            <ReportVideo open={this.state.dialogReportVideo} callback={this.CollDialogReportVideo} />

          </>
        }
        {selectedMenu === Admin.MENUS.ADJUST_USER_REPORT_VIEWER &&
          <>
            <Row>
              <Col xs={4} sm={{ offset: 1 }} style={{ marginTop: "10px" }} lg={{ span: 1, offset: 1 }}><FormLabel style={{ width: "100px" }}>Period From</FormLabel></Col>
              <Col xs={8} style={{ marginTop: "10px" }} lg={2}>
                <DatePicker selected={this.state.fromReport} dateFormat="dd/MM/yyyy" onChange={date => this.setState({ fromReport: date })} />
              </Col>
              <Col xs={4} sm={{ offset: 1 }} style={{ marginTop: "10px" }} lg={1}><FormLabel style={{ width: "100px" }}>Period To</FormLabel></Col>
              <Col xs={8} style={{ marginTop: "10px" }} lg={2}>
                <DatePicker selected={this.state.toReport} dateFormat="dd/MM/yyyy" onChange={date => this.setState({ toReport: date })} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReportLibrary({ key: 1 })} defaultChecked={reportFromTitle === 1} name="radio" /></Col>
              <Col xs={3} lg={1}><FormLabel >Username</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={this.options()} isDisabled={reportFromTitle !== 1} onChange={(e) => this.handleChangeReportUser(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReportLibrary({ key: 2 })} defaultChecked={reportFromTitle === 2} name="radio" /></Col>
              <Col xs={3} lg={1}><FormLabel>Company</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={this.optionsCompanys()} isDisabled={reportFromTitle !== 2} onChange={(e) => this.handleChangeReportCompany(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={1} lg={1} style={{ textAlign: "center", marginTop: "7px" }}><input type="radio" onClick={() => this.handleSelectReportLibrary({ key: 3 })} defaultChecked={reportFromTitle === 3} name="radio" /></Col>
              <Col xs={3} lg={1}  ><FormLabel style={{ width: "100px" }}>Title</FormLabel></Col>
              <Col xs={12} sm={8} lg={9}>
                <Select isClearable options={_library} isDisabled={reportFromTitle !== 3} onChange={(e) => this.handleChangeLibraryViewer(e)} />
              </Col>
            </Row>

            <Row style={{ marginTop: "10px" }}>
              <Col xs={12} style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="outline-secondary" disabled={this.state.loading} onClick={() => this.handleSearch()}>Search</Button>
                <Button style={{ marginLeft: 15 }} variant="outline-secondary" disabled={this.state.loading} onClick={() => this.downloadLibraryCsv()}>Download</Button>
              </Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col>
                {this.state.loading ? <Spinner />
                  : <BootstrapTable
                    keyField='id'
                    id="admin-report"
                    wrapperClasses="table-responsive"
                    striped hover bootstrap4
                    data={userReportViewer}
                    columns={this.genReportViewerColumns()}
                    filter={filterFactory()}
                    pagination={paginationFactory({
                      sizePerPage: 10,
                      hidePageListOnlyOnePage: true,
                      hideSizePerPage: true,
                    })}
                  />}
              </Col>
            </Row>
            <ReportVideo open={this.state.dialogReportVideo} callback={this.CollDialogReportVideo} />

          </>
        }
      </Container>
    )
  }
  //!video
  genVideoColumns = () => {
    const columns = []
    columns.push({ dataField: 'id', text: 'Video ID', sort: true, headerStyle: { textAlign: "center", width: '120px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
    columns.push({ dataField: 'title', text: 'Title', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'file_name', text: 'File Name', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    if (this.state.section) columns.push({ dataField: 'Sort', text: 'Sort', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '100px' }, formatter: this.actionFormatterSort })
    columns.push({ dataField: 'action', text: 'Action', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '210px', maxWidth: '310px' }, formatter: this.actionFormatterVideo })
    return columns
  }

  genColumns = () => {
    const columns = []
    columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '90px' }, style: { verticalAlign: "middle", textAlign: "center" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
    columns.push({ dataField: 'firstName', text: 'First Name', headerStyle: { textAlign: "center", width: '175px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'lastName', text: 'Last Name', headerStyle: { textAlign: "center", width: '175px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'username', text: 'Username', headerStyle: { textAlign: "center", width: '175px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'email', text: 'Email', headerStyle: { textAlign: "center", width: '175px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'company', text: 'Company', headerStyle: { textAlign: "center", width: '175px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
    columns.push({ dataField: 'action', text: 'Action', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '330px', maxWidth: '510px' }, formatter: this.actionFormatter })
    return columns
  }

  genVideoViewerColumns = () => {
    const { reportFrom } = this.state
    let columns = []
    if (reportFrom === 1) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'username', text: 'User', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'company', text: 'Company', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'Average', text: 'Avg  Time Spend / Session', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '200px' }, style: { textAlign: "center", verticalAlign: "middle", wordBreak: "break-all", }, sort: true })
      columns.push({ dataField: 'action', text: 'Video', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, style: { textAlign: "center" }, formatter: this.actionUser })
    }
    if (reportFrom === 2) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'company', text: 'Company', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'actionUser', text: 'Users', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionCompany })
      columns.push({ dataField: 'actionVideo', text: 'Videos', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionCompany2 })
    }
    if (reportFrom === 3) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'video_title', text: 'Video', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'viewNumber', text: 'Total Number of View', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'actionViewer', text: 'Viewer', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionViewer })
      columns.push({ dataField: 'actionCompany', text: 'Company', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionViewer2 })
      columns.push({ dataField: 'Average', text: 'Average View Duration', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '200px' }, style: { textAlign: "center", verticalAlign: "middle", wordBreak: "break-all", }, sort: true })
    }
    return columns
  }

  genReportViewerColumns = () => {
    const { reportFromTitle } = this.state
    let columns = []
    if (reportFromTitle === 1) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'username', text: 'User', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'company', text: 'Company', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'action', text: 'Title', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, style: { textAlign: "center" }, formatter: this.actionUser3 })
    }
    if (reportFromTitle === 2) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'company', text: 'Company', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'actionUser', text: 'Users', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionCompany })
      columns.push({ dataField: 'actionTitle', text: 'Title', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionCompany3 })
    }
    if (reportFromTitle === 3) {
      columns.push({ dataField: 'id', text: 'No', headerStyle: { textAlign: "center", width: '100px' }, style: { verticalAlign: "middle" }, sort: true, filter: textFilter({ placeholder: " " }), formatter: this.idFormatter })
      columns.push({ dataField: 'title', text: 'Title', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'num', text: 'Total Number of View', headerStyle: { textAlign: "center", width: '200px' }, style: { verticalAlign: "middle", wordBreak: "break-all" }, sort: true, filter: textFilter({ placeholder: " " }) })
      columns.push({ dataField: 'actionViewer', text: 'Viewer', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionUserLibrary })
      columns.push({ dataField: 'actionCompany', text: 'Company', headerStyle: { verticalAlign: "middle", textAlign: "center", width: '100px', maxWidth: '510px' }, formatter: this.actionViewerCompanyLibrary })
    }
    return columns
  }

  handleSelectReport = (e: any) => {
    if (e.key === 1) this.setState({ reportFrom: e.key, userVideoViewer: [], videoId: undefined, company: undefined })
    else if (e.key === 2) this.setState({ reportFrom: e.key, userVideoViewer: [], videoId: undefined, username: undefined })
    else this.setState({ reportFrom: e.key, userVideoViewer: [], company: undefined, username: undefined })
  }

  handleSelectReportLibrary = (e: any) => {
    if (e.key === 1) this.setState({ reportFromTitle: e.key, userReportViewer: [], videoId: undefined, company: undefined })
    else if (e.key === 2) this.setState({ reportFromTitle: e.key, userReportViewer: [], videoId: undefined, username: undefined })
    else this.setState({ reportFromTitle: e.key, userReportViewer: [], company: undefined, username: undefined })
  }

  //! action for report
  actionUser = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Videos" aria-label="Videos">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportVideo(row.username, 1, "Video")}>
            <FiVideo />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionCompany = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Users" aria-label="Users">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportVideoUser(row.company, 2, "Users")}>
            <FaUserFriends />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionCompany2 = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Videos" aria-label="Videos">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportVideoCompany(row.company, 1, "Videos")}>
            <FiVideo />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionCompany3 = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Library" aria-label="Videos">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportLibraryIdCompany(row.company, 5, "Library", row.libraryId)}>
            <MdLibraryBooks />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionUser3 = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Library" aria-label="Videos">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportLibraryIdUsername(row.username, 8, "Library", row.libraryId)}>
            <MdLibraryBooks />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionViewer = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="Viewer" aria-label="Sort Up">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportVideoCompany2(row.video_id, 4, "Viewer")}>
            <GrView />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionUserLibrary = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="Viewer" aria-label="Sort Up">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportUserLibrary(row.libraryId, 7, "Viewer", row.userId)}>
            <GrView />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionViewer2 = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Company" aria-label="Sort Up">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportVideoCompany2(row.video_id, 3, "Company")}>
            <GiHomeGarage />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  actionViewerCompanyLibrary = (cell, row) => {
    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="View Company" aria-label="Sort Up">
          <IconButton aria-label="delete" onClick={() => this.initDialogReportCompanyLibrary(row.libraryId, 6, "Company", row.companyId)}>
            <GiHomeGarage />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }
  //! action for report ------------------------------------------------

  idFormatter = (cell, row) => {
    return (
      <div>
        <span style={{ fontSize: 18, color: row.isDisabled ? "red" : "green" }}>●</span>
        {` ${cell}`}
      </div>
    )
  }

  actionFormatter = (cell, row) => {
    return (
      <div style={{ "textAlign": "left" }}>
        <LightTooltip title="User Detail" aria-label="add">
          <IconButton aria-label="delete" onClick={() => this.initDialogViewDetail(row.id, row)}>
            <BiCommentDetail />
          </IconButton>
        </LightTooltip>
        <LightTooltip title="Change Password" aria-label="Change Password">
          <IconButton disabled={!row.requirePassword || (row.username === "admin" && Auth.getUserName() !== "admin")} aria-label="delete" onClick={() => this.initDialogChgPwd(row.id)}>
            <CgPassword />
          </IconButton>
        </LightTooltip>
        <LightTooltip title={row.isDisabled ? "User Disabled" : "User Enabled"} aria-label="add">
          <IconButton aria-label="delete" onClick={() => this.initDialogDisUser(row.id, !row.isDisabled, "isDisabled")} disabled={row.username === "admin"}>
            {row.isDisabled ? <FiUserX style={{ color: "red" }} /> : <FiUserPlus style={{ color: "green" }} />}
          </IconButton>
        </LightTooltip>
        <LightTooltip title={row.canViewMacroEco ? "Macroeconomics Enabled" : "Macroeconomics Disabled"} aria-label="add">
          <IconButton aria-label="delete" onClick={() => this.initDialogDisUser(row.id, !!row.canViewMacroEco, "canViewMacroEco")}>
            {row.canViewMacroEco ? <MdAssignment style={{ color: "green" }} /> : <MdAssignmentLate style={{ color: "red" }} />}
          </IconButton>
        </LightTooltip>
        <LightTooltip title={row.canViewReport ? "Report Enabled" : "Report Disabled"} aria-label="add">
          <IconButton aria-label="delete" onClick={() => this.initDialogDisUser(row.id, !!row.canViewReport, "canViewReport")}>
            {row.canViewReport ? <BsGraphUp style={{ color: "green" }} /> : <BsGraphDown style={{ color: "red" }} />}
          </IconButton>
        </LightTooltip>
        <LightTooltip title={row.canViewVideo ? "Video Enabled" : "Video Disabled"} aria-label="add">
          <IconButton aria-label="delete" onClick={() => this.initDialogDisUser(row.id, !!row.canViewVideo, "canViewVideo")}>
            {row.canViewVideo ? <FiVideo style={{ color: "green" }} /> : <FiVideoOff style={{ color: "red" }} />}
          </IconButton>
        </LightTooltip>
        <LightTooltip title={"Delete"} aria-label="Delete">
          <IconButton disabled={row.username === "admin" || row.username === Auth.getUserName()} aria-label="delete" onClick={() => this.initDialogDeleteUser(row.id)}>
            <MdDeleteForever style={{ color: (row.username === "admin" || row.username === Auth.getUserName()) ? "#ccc" : "red" }} />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  SortVideo = async (key, video) => {
    const { section } = this.state
    await ajax.get("/video/sort?key=" + key + "&id=" + video.id + "&video_order=" + video.video_order + "&section=" + section).then(result => result).catch(e => e)
    await this.reloadVideo()
  }

  //! action Sort
  actionFormatterSort = (cell, row) => {
    const { section, videos } = this.state
    const _videos = section ? videos.filter(v => v.section === section).sort(function (a, b) { return parseInt(a.video_order) - parseInt(b.video_order) }) : videos

    return (
      <div style={{ "textAlign": "center" }}>
        <LightTooltip title="Sort Up" aria-label="Sort Up">
          <IconButton aria-label="delete" disabled={row.video_order <= 1} onClick={() => this.SortVideo("Up", row)}>
            <BiSortUp />
          </IconButton>
        </LightTooltip>
        <IconButton aria-label="delete">
          {row.video_order}
        </IconButton>
        <LightTooltip title="Sort Down" aria-label="Sort Down">
          <IconButton aria-label="delete" disabled={row.video_order === _videos.length} onClick={() => this.SortVideo("Down", row)}>
            <BiSortDown />
          </IconButton>
        </LightTooltip>
      </div>
    )
  }
  //! action video
  actionFormatterVideo = (cell, row) => {
    return (
      <div style={{ "textAlign": "left" }}>
        <LightTooltip title="Edit Video" aria-label="Edit Video">
          <IconButton aria-label="delete" onClick={() => this.initDialogPreDes(row)}>
            <FiEdit />
          </IconButton>
        </LightTooltip>
        <LightTooltip title={!row.is_disabled ? "Video Enabled" : "Video Disabled"} aria-label={!row.is_disabled ? "Enable Video" : "Disable Video"}>
          <IconButton aria-label="delete" onClick={() => this.initDialogDis(row.id, row.is_disabled)}>
            {!row.is_disabled ? <FiVideo style={{ color: "green" }} /> : <FiVideoOff style={{ color: "red" }} />}
          </IconButton>
        </LightTooltip>
        <LightTooltip title="Delete Video" aria-label="Delete Video">
          <IconButton aria-label="delete" onClick={() => this.initDialogDe(row.id, row.file_name)}>
            <AiOutlineDelete style={{ color: "red" }} />
          </IconButton>
        </LightTooltip>
        <LightTooltip title="Welcome Video" aria-label="Welcome Video">
          <IconButton aria-label="delete" onClick={() => this.initDialogWelcome(row.id)} disabled={row.welcome}>
            {row.welcome ? <GiVideoConference style={{ color: "green" }} /> : <GiVideoConference style={{ color: "#ccc" }} />}
          </IconButton>
        </LightTooltip>
      </div>
    )
  }

  initDialogNewUser = (userId?) => {
    (document.activeElement as HTMLElement).blur()
    let dialogNewUser = {
      show: true,
      val: userId,
      page: "new"
    }
    this.setState({ dialogNewUser })
  }

  initDialogNewVideo = (userId?) => {
    (document.activeElement as HTMLElement).blur()
    let dialogNewVideo = {
      show: true,
      val: userId,
    }
    this.setState({ dialogNewVideo })
  }

  initDialogChgPwd = (userId) => {
    (document.activeElement as HTMLElement).blur()
    let dialogChgPwd = {
      show: true,
      val: userId,
    }
    this.setState({ dialogChgPwd })
  }

  CollDialogReportVideo = () => {
    (document.activeElement as HTMLElement).blur()
    let dialogReportVideo = {
      show: false,
      val: { user: undefined },
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportVideo = (user, key, title) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { user, key, from, to },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportVideoCompany = (company, key, title) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { company, key, from, to },
      title
    }
    this.setState({ dialogReportVideo })
  }
  initDialogReportLibraryIdCompany = (company, key, title, libraryId) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { company, key, from, to, libraryId },
      title
    }
    this.setState({ dialogReportVideo })
  }
  initDialogReportLibraryIdUsername = (username, key, title, libraryId) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.fromReport).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.toReport).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { username, key, from, to, libraryId },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportVideoCompany2 = (video, key, title) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { video, key, from, to },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportCompanyLibrary = (libraryId, key, title, companyId) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.fromReport).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.toReport).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { libraryId, key, from, to, companyId },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportUserLibrary = (libraryId, key, title, userId) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.fromReport).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.toReport).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { libraryId, key, from, to, userId },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogReportVideoUser = (company, key, title) => {
    (document.activeElement as HTMLElement).blur()
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let dialogReportVideo = {
      show: true,
      val: { company, key, from, to },
      title
    }
    this.setState({ dialogReportVideo })
  }

  initDialogViewDetail = (userId, row) => {
    (document.activeElement as HTMLElement).blur()
    let dialogDetail = {
      show: true,
      val: userId,
      row,
      page: "edit"
    }
    this.setState({ dialogDetail })
  }

  initDialogDeleteUser = (userId) => {
    (document.activeElement as HTMLElement).blur()
    let dialogDeleteUser = {
      show: true,
      val: userId,
    }
    this.setState({ dialogDeleteUser })
  }

  initDialogPreDes = (val) => {
    (document.activeElement as HTMLElement).blur()
    let _tags = []
    for (const _tag of JSON.parse(val.tag)) {
      const deTags = this.state.tags ? (this.state.tags || []).find(sec => sec.tagname === _tag) : undefined
      _tags.push(deTags)
    }
    let dialogPreDes = {
      show: true,
      val,
      _tags
    }
    this.setState({ dialogPreDes })
  }

  initDialogDisUser = (userId, isDisabled, key) => {
    (document.activeElement as HTMLElement).blur()
    let dialogDisUser = {
      show: true,
      val: userId,
      curStatus: isDisabled,
      key
    }
    this.setState({ dialogDisUser })
  }

  initDialogDis = (videoId, isDisabled) => {
    (document.activeElement as HTMLElement).blur()
    let dialogDisVideo = {
      show: true,
      val: videoId,
      curStatus: isDisabled ? true : false,
    }

    this.setState({ dialogDisVideo })
  }

  initDialogDe = (videoId, file_name) => {
    (document.activeElement as HTMLElement).blur()
    let dialogDeVideo = {
      show: true,
      val: videoId,
      curStatus: file_name,
    }
    this.setState({ dialogDeVideo })
  }

  initDialogWelcome = (videoId) => {
    (document.activeElement as HTMLElement).blur()
    let dialogWelcomeVideo = {
      show: true,
      val: videoId,
    }
    this.setState({ dialogWelcomeVideo })
  }

  CollDialogWelcome = async (id) => {
    if (id) {
      let body = {
        id
      }
      await ajax.post(`/video/welcome_video`, body).then(res => res.data).catch(err => console.log(err))
      await this.reloadVideo()
    }
    let dialogWelcomeVideo = {
      show: false,
      val: undefined,
    }
    this.setState({ dialogWelcomeVideo })
    return true
  }

  handleNewUser = (data) => {
    return ajax.post(`/user/${data.update ? "update" : "create"}`, data.data).then(result => {
      console.log(data.data)
      this.reload()
      return true
    }).catch(e => {
      const message = (((e || {}).response || {}).data || {}).msg
      if (message) {
        alert(message)
      }

      return false
    })
  }

  userCancel = () => {
    let dialogDetail = {
      show: false,
      val: undefined,
      row: {}
    }
    let dialogNewUser = {
      show: false,
      val: undefined,
    }
    this.setState({ dialogNewUser, dialogDetail })
  }

  handleNewVideoCallback = (result) => {
    const { dialogNewVideo } = this.state
    if (result) this.reloadVideo()
    this.setState({ dialogNewVideo: { ...dialogNewVideo, show: false } })
  }

  handleDescription = (result) => {
    const { dialogPreDes } = this.state
    if (result) this.reloadVideo()
    this.setState({ dialogPreDes: { ...dialogPreDes, show: false } })
  }

  handleChangeSection = (e) => {
    this.state.videos.forEach(vdo => vdo.Sort = moment()) // force re-render sort column

    if (e) this.setState({ section: e.value, videos: this.state.videos })
    else this.setState({ section: undefined, videos: this.state.videos })
  }

  handleChgPwd = (userId, password) => {
    let data = password
    data["userId"] = userId
    return ajax.put("/user/password", data).then(result => {
      this.setState({
        dialogChgPwd: {
          show: false,
          val: undefined,
        }
      })
      return true
    }).catch(e => {
      console.log(e)
      alert("Error, please try again [5]")
      return false
    })
  }

  handleDisUser = (userId, isDisabled, key) => {
    let data = {
      userId,
      isDisabled: isDisabled ? false : true,
      key
    }
    return ajax.put("/user/status", data).then(result => {
      this.reload()
      return true
    }).catch(e => {
      console.log(e)
      return false
    })
  }

  handleDisVideo = async () => {
    await this.reloadVideo()
    let dialogDisVideo = {
      show: false,
      val: undefined,
    }
    this.setState({ dialogDisVideo })
  }

  handleDeleteVideo = async () => {
    await this.reloadVideo()
    let dialogDeVideo = {
      show: false,
      val: undefined,
    }
    this.setState({ dialogDeVideo })
  }

  handleDataUser = (page, value) => {
    const { _company } = this.state
    let val = _company
    page === "new" ? this.setState({
      dialogNewUser: {
        show: false,
        val: undefined,
      },
      dialogDataUser: {
        show: true,
        val,
        page,
        value
      }
    }) : this.setState({
      dialogDetail: {
        show: false,
        val: value,
        row: {}
      },
      dialogDataUser: {
        show: true,
        val,
        page,
        value
      }
    })
  }

  handleData = (key, page, value) => {
    const { tags, sections } = this.state
    let val = key === "Tag" ? tags : sections
    page === "new" ? this.setState({
      dialogNewVideo: {
        show: false,
        val: undefined,
      },
      dialogData: {
        show: true,
        val,
        key,
        page
      }
    })
      : this.setState({
        dialogPreDes: {
          show: false,
          val: value,
          tags: [],
        },
        dialogData: {
          show: true,
          val,
          key,
          page,
          value
        }
      })
  }

  handleDataKeyUser = async (page, val) => {
    const _company = await data.company()
    this.setState({ _company })
    if (page === "new") {
      this.setState({
        dialogNewUser: { show: true, val },
        dialogDataUser: { show: false, }
      })
    } else {
      this.setState({
        dialogDetail: {
          show: true,
          row: val
        },
        dialogDataUser: { show: false, }
      })
    }
  }

  handleDataKey = async (key, page, val) => {
    let tags = this.state.tags
    let sections = this.state.sections

    if (key === "Tag") {
      tags = await data.tags()
    } else {
      sections = await data.sections()
    }

    let _tags = []

    if (page === "edit") {
      for (const _tag of JSON.parse(val.tag)) {
        const deTags = this.state.tags ? (this.state.tags || []).find(sec => sec.tagname === _tag) : undefined
        _tags.push(deTags)
      }
    }


    this.setState({ tags, sections })

    page === "new" ? this.setState({
      dialogNewVideo: {
        show: true,
      },
      dialogData: {
        show: false,
      }
    })
      : this.setState({
        dialogPreDes: {
          show: true,
          tags: [],
          _tags,
          val,
        },
        dialogData: {
          show: false,
          val: undefined
        }
      })
  }

  downloadCsv = async () => {
    const { videoId, username, company, reportFrom } = this.state
    this.setState({ loading: true })
    const from = moment.utc(moment(this.state.from).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(this.state.to).format("YYYY/MM/DD") + " 23:59:59").format()
    let _where = {
      from,
      to,
      reportFrom,
      videoId: undefined, username: undefined, company: undefined,
    }
    if (reportFrom === 1) _where.username = username
    if (reportFrom === 2) _where.company = company
    if (reportFrom === 3) _where.videoId = videoId
    const where = JSON.stringify(_where)

    await ajax.download("/video/report/download?where=" + where).then((result) => {
      FileDownload("\ufeff" + result.data, "export_report.csv", "text/csv;charset=utf-8")
      this.setState({ loading: false })
    })
      .catch((e) => {
        alert(e.response.status + " " + e.response.statusText)
      })
  }

  downloadLibraryCsv = async () => {
    const {
      fromReport,
      toReport,
      libraryId,
      username,
      company,
      reportFromTitle
    } = this.state
    this.setState({ loading: true })
    const from = moment.utc(moment(fromReport).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(toReport).format("YYYY/MM/DD") + " 23:59:59").format()
    const query = {
      from,
      to,
      libraryId,
      username,
      company,
      reportFromTitle
    }
    await ajax.download(`/report/library/download?data=${JSON.stringify(query)}`)
      .then(result => {
        FileDownload("\ufeff" + result.data, "export_report.csv", "text/csv;charset=utf-8")
        this.setState({ loading: false })
      })
      .catch(e => alert(e.response.status + " " + e.response.statusText))
  }
  handleSearch = async () => {
    const {
      fromReport,
      toReport,
      libraryId,
      username,
      company,
      reportFromTitle
    } = this.state
    this.setState({ loading: true })
    const from = moment.utc(moment(fromReport).format("YYYY/MM/DD")).format()
    const to = moment.utc(moment(toReport).format("YYYY/MM/DD") + " 23:59:59").format()
    const query = {
      from,
      to,
      libraryId,
      username,
      company,
      reportFromTitle
    }
    const userReportViewer = await ajax.get(`/report/libraryOfView?data=${JSON.stringify(query)}`)
      .then(result => result.data)
      .catch(() => [])

    this.setState({ userReportViewer, loading: false })
  }
}

export default Admin
